import React from "react";
import { Flex, Link, Text } from "@chakra-ui/react";
import CustomIcon from "../../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  href: string;
}

/**
 * 네이버 공식 도움말로 나가는 보조 링크.
 *
 * 해외 출고지·배송비 템플릿·API 설정 모달에만 붙는다.
 * 해외 판매 권한 모달에는 두지 않는다 — 전달서 §8.2 가 명시적으로 금지한다.
 */
function PathPickStartGuideOfficialGuideLink({ href }: Props) {
  const { t } = useI18nHelper();
  const label = t("path_pick_guide:official_guide");

  return (
    <Flex justifyContent={"flex-start"}>
      <Link
        href={href}
        isExternal={true}
        rel={"noopener noreferrer"}
        aria-label={`${label} (${t("path_pick_guide:external_link_suffix")})`}
        display={"inline-flex"}
        alignItems={"center"}
        gap={"4px"}
        color={"#1272EF"}
        _hover={{ textDecoration: "underline" }}
      >
        <Text textStyle={"body-sm-medium"}>{label}</Text>
        <CustomIcon src={"external-link"} width={14} height={14} />
      </Link>
    </Flex>
  );
}

export default PathPickStartGuideOfficialGuideLink;
